import { AlertCircle } from "@tamagui/lucide-icons";
import React from "react";
import { Platform } from "react-native";
import { GetProps, XStack } from "tamagui";

import { Text } from "../Typography";

type ErrorLabelProps = {
  children: React.ReactNode;
  id?: string;
  icon?: React.ReactNode;
  textProps?: GetProps<typeof Text>;
} & Omit<GetProps<typeof XStack>, "id">;

export default function ErrorLabel({
  children,
  id,
  icon = <AlertCircle size="$150" color="$red" strokeWidth={2.5} />,
  textProps,
  ...containerProps
}: ErrorLabelProps) {
  return (
    <XStack
      id={id}
      gap="$50"
      alignItems="center"
      {...(Platform.OS === "web"
        ? { role: "alert" }
        : { accessibilityLiveRegion: "assertive" })}
      {...containerProps}
    >
      {icon}
      <Text size="$sm" color="$red" {...textProps}>
        {children}
      </Text>
    </XStack>
  );
}
